import React, {Component} from "react";
import {connect} from "react-redux";
import t from "i18n";


export default class FrequencyFilter extends Component {

  render() {
    const {frequency, updateFrequency} = this.props;
    return (
      <div className={"event-registrant-frequency-container"}>
        <div
          className={"event-registrant-frequency-option " + (frequency == "DAILY" ? 'selected' : '')}
          onClick={() => updateFrequency('DAILY')}>{t('DAILY')}
        </div>
        <div
          className={"event-registrant-frequency-option " + (frequency == "MONTHLY" ? 'selected' : '')}
          onClick={() => updateFrequency('MONTHLY')}>{t('MONTHLY')}
        </div>
        <div
          className={"event-registrant-frequency-option " + (frequency == "YEARLY" ? 'selected' : '')}
          onClick={() => updateFrequency('YEARLY')}>{t('YEARLY')}
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/EventRegistrantLinechart/FrequencyFilter.js